export default __webpack_public_path__ + "static/center-es-97279707782cc6a718390d0479f57eb0.webp";